export default __webpack_public_path__ + "static/media/ctgb_thumb.1fd984f9.png";